<template>
    <listSuppliersComponent />
</template>

<script>
import listSuppliersComponent from "@/views/suppliers/pages/list_suppliers/components/list_suppliers_component.vue"
export default {
    name: "suppliers",
    components: {
        listSuppliersComponent
    },
}
</script>

<style lang="css" scoped>
</style>